import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { tasignalPDFUrl } from '../../../configs/ContactConfig';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import Tab from '../../common/tab';
import { getQueryParams } from '../../helpers/Common';
import Indicators from '../ta-signals/indicators/Indicators';
import Deceptive from '../ta-signals/deceptive/Deceptive';
import PriceVolume from '../ta-signals/price-volume/PriceVolume';
import ScrollComponent from './../../common/ScrollComponent';
import PreRender from './../../common/PreRender';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';
import './TASignalsStyle.scss';

const mapTab = {
  IndicatorSignal: 1,
  DeceptiveOrders: 2,
  PriceVolumeAnalysis: 3,
};

class TASignals extends Component {
  constructor(props) {
    super(props);

    const tabFromQuery = mapTab[getQueryParams('tab')];
    this.state = {
      currentTab:
        tabFromQuery ||
        props.tab ||
        currentState.get(ConstCommon.listComponent.TASignals, 'currentTab') ||
        1,
    };
  }

  changeTab = currentTab => {
    currentState.add(
      ConstCommon.listComponent.TASignals,
      'currentTab',
      currentTab,
    );
    this.setState({ currentTab });
  };

  render() {
    const { id } = this.props;
    return (
      <PreRender {...this.props}>
        <ComponentNameProvider value={ConstCommon.listComponent.TASignals}>
          <Provider value={id}>
            <ScrollComponent>
              <div
                style={{ minHeight: '100%' }}
                className="top-nav px-20 d-flex flex-column h-auto flex-shrink-0"
              >
                <div className="sticky pt-8">
                  <Tab
                    locks={[2, 3]}
                    currentTab={this.state.currentTab}
                    listTab="tasignals.lstTab"
                    changeTab={this.changeTab}
                  />

                  {this.state.currentTab === 1 && (
                    <div className="pd-top-navigation--right pd-top-navigation--right-indica mb-10">
                      <a
                        href={tasignalPDFUrl}
                        className="btn btn-cus-nomal bg-b-color-3 font-weight-bold"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <i className="icon-printer-tool" />{' '}
                        {I18n.t('tasignals.methodology')}
                      </a>
                    </div>
                  )}
                </div>

                <div className="tab-content h-auto d-flex flex-fill flex-column">
                  {this.state.currentTab === 1 && <Indicators />}
                  {this.state.currentTab === 2 && (
                    <Deceptive subTab={this.props.subTab} />
                  )}
                  {this.state.currentTab === 3 && <PriceVolume />}
                </div>
              </div>
            </ScrollComponent>
          </Provider>
        </ComponentNameProvider>
      </PreRender>
    );
  }
}

export default TASignals;
